import React from 'react'
import {useDraggable} from "@dnd-kit/core"

const FormBuilderItens = ({item: {id, label, Icon}}) => {
    const {
        attributes,
        listeners,
        setNodeRef, isDragging,
    } = useDraggable({id})

    return (
        <button
            ref={setNodeRef}
            className={"drag-menu-button" + (isDragging ? " opacity-50" : "")}
            {...listeners}
            {...attributes}
        >
            <Icon size={30}/>
            <span className={"font-[16px]"}>{label}</span>
        </button>
    )
}

export default FormBuilderItens